import { render, staticRenderFns } from "./parameter-monitoring-detail-form.vue?vue&type=template&id=3b1c756e"
import script from "./parameter-monitoring-detail-form.vue?vue&type=script&lang=js"
export * from "./parameter-monitoring-detail-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports